import { Box } from "@chakra-ui/react";
import { useAppSelector } from "hooks/store/hooks";
import NotificationPanel from "pages/DashboardPage/NotificationPanel";
import React from "react";
import { selectColorThemeMode } from "stores/ui/uiSlice";
import { useDeviceDetection } from "utils/misc";

const DisplayArea = ({ children }) => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const { isDesktop } = useDeviceDetection();

  return (
    <>
    <NotificationPanel/>
    <Box
      w="full"
      bg={`${colorThemeMode}_tertiary`}
      color={`${colorThemeMode}_text`}
      mt={{ base: "0", md: isDesktop === "computer" && "60px" }}
      // pb={{ base: "60px", md: "0px" }}
      height={"fit-content"}
      mb={{base:"30px" , md:"0px", lg:"0px"}}
      padding={"10px"}
    >
      {children}
    </Box>
    </>
  );
};

export default DisplayArea;